var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.535,
    height: 25.773,
    viewBox: "0 0 25.535 25.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.835,17.288l1.419-1.611a.353.353,0,0,1,.607.287v7.318A2.286,2.286,0,0,1,17.733,25.7H2.128A2.286,2.286,0,0,1,0,23.283V5.566A2.286,2.286,0,0,1,2.128,3.15H14.253a.414.414,0,0,1,.253.69L13.087,5.45a.331.331,0,0,1-.253.116H2.128V23.283H17.733V17.57A.425.425,0,0,1,17.835,17.288ZM24.778,7.131,13.136,20.348l-4.008.5a1.965,1.965,0,0,1-2.022-2.3l.443-4.55L19.192.789a2.376,2.376,0,0,1,3.666,0l1.915,2.174a3.237,3.237,0,0,1,0,4.167ZM20.4,8.686,17.822,5.762,9.585,15.119l-.324,3.287,2.895-.367ZM23.27,4.675,21.355,2.5a.425.425,0,0,0-.656,0l-1.37,1.555L21.9,6.98l1.37-1.555A.589.589,0,0,0,23.27,4.675Z",
    transform: "translate(0 0.075)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.46feca41492cf7acea3b6c8f6a0001ec.svg";
export { ForwardRef as ReactComponent };